<template>
    <div>
        <div class="marketplace-logo border-bottom"
             :style="{'background-color': backgroundColor}">
            <img ref="logo" :src="logo" :alt="name" class="p-4"/>
        </div>
        <div class="px-3 py-2 font-14 text-muted">
            {{ template.categories.map(category => category.name).join(', ') }}
        </div>
        <div class="px-3 py-1 font-20">
            {{ name }}
        </div>
        <div class="px-3 py-2 font-16">
            {{ description | snippet(140) }}
        </div>
        <slot name="card-footer"></slot>
    </div>
</template>

<script>
export default {
    name: 'MarketplaceAutomationTemplateCard',
    props: {
        template: {
            type: Object,
            required: true
        }
    },
    computed: {
        cardContent() {
            return _.isPlainObject(this.template.cardContent) ? this.template.cardContent : {}
        },

        name() {
            return this.cardContent.name || 'Unknown'
        },

        description() {
            return this.cardContent.description || 'No description'
        },

        hasImage() {
            return this.cardContent.logo
        },

        logo() {
            return this.hasImage ? this.cardContent.logo : '/topPanel.logo.png'
        },

        backgroundColor() {
            if (this.hasImage) {
                return this.cardContent.color ? this.cardContent.color : 'white'
            }
            return '#8b3694'
        }
    },
    methods: {
        setFallbackImage() {
            const img = this.$refs.logo
            if (img) {
                img.addEventListener('error', event => {
                    event.target.src = '/topPanel.logo.png'
                    event.onerror = null
                })
            }
        }
    },
    mounted() {
        this.setFallbackImage()
    }
}
</script>

<style scoped lang="scss">
    .marketplace-logo img {
        aspect-ratio: 16 / 9;
        object-fit: contain;
        min-height: 100px;
        width: 100%;
        vertical-align: top;
    }
</style>
